import React, { useState, useEffect } from "react";
import { Popover, Input, Button, message } from "antd";
import { EditFilled } from '@ant-design/icons';

const CostPricePopover = ({ itemId, onSave, currentPrimeCost, isEditing = false, priceIndex }) => {
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [primeCost, setPrimeCost] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isEditing) {
            setPrimeCost(currentPrimeCost || "");
        } else {
            setPrimeCost("");
        }
    }, [isEditing, currentPrimeCost, popoverVisible]);

    const handleVisibilityChange = (visible) => {
        setPopoverVisible(visible);
        if (!visible && isEditing) {
            setPrimeCost(currentPrimeCost || "");
        } else if (!visible && !isEditing) {
            setPrimeCost("");
        }
    };

    const handleSave = async () => {
        const primeCostValue = primeCost ? parseFloat(primeCost) : null;

        if (primeCost && isNaN(primeCostValue)) {
            message.error("Prime cost must be a valid number");
            return;
        }

        setLoading(true);
        try {
            await onSave({
                itemId,
                price_index: priceIndex,
                prime_cost: primeCostValue,
                total_cost: primeCostValue * 1.02,
            });

            message.success("Cost price updated successfully");
            setPopoverVisible(false);
        } catch (error) {
            console.error("Error saving cost price:", error);
            message.error(error.response?.data?.message || "Failed to save cost price");
        } finally {
            setLoading(false);
        }
    };

    const content = (
        <div style={{ width: 250 }}>
            <div style={{ marginBottom: 8 }}>
                <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>Prime Cost</label>
                <Input
                    value={primeCost}
                    onChange={(e) => setPrimeCost(e.target.value)}
                    placeholder="Enter prime cost"
                    style={{ width: "100%", marginBottom: 8 }}
                    onPressEnter={handleSave}
                />
            </div>
            <div style={{ textAlign: "right" }}>
                <Button
                    type="primary"
                    onClick={handleSave}
                    loading={loading}
                >
                    Save
                </Button>
            </div>
        </div>
    );

    return (
        <Popover
            content={content}
            title="Edit Cost Price"
            visible={popoverVisible}
            onVisibleChange={handleVisibilityChange}
            trigger="click"
            placement="right"
        >
            <EditFilled
                style={{ color: "#fd7e14", cursor: "pointer", fontSize: "14px" }}
            />
        </Popover>
    );
};

export default CostPricePopover; 